import { ConfidenceFlagWrapper } from '@/components/ConfidenceFlagWrapper';
import { BookAppointmentProvider } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import { MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY } from '@/constants/experimentConstants';
import { useBookingFlowRedesign } from '@/features/booking-flow/useBookingFlowRedesign';
import { useFlagResolveTimeout } from '@/features/booking-flow/useFlagResolveTimeout';
import { ConfidenceFlagProvider } from '@/hooks/useConfidenceFlag';
import { ListCardsV2Provider } from '@/hooks/useListCardsV2';
import { NotFound } from '@/pages/_exports';

import PlacePageV2 from '../../../features/PlacePages/PlacePage';
import ProfilePage from '../../../features/ProfilePages/ProfilePage';
import usePlaceData from './index.hooks';

export default function PlacePage() {
  const { place, loading, is404, isSistaminuten } = usePlaceData();
  // Variant: a bookmarked /places/x?ss=…&sr=… must not auto-open the modal. Suppress only —
  // never redirect to a step (R3). The provider's one-shot URL sync waits for the flag
  // decision; unresolved past the timeout is treated as control (fail-closed).
  const bookingFlowRedesign = useBookingFlowRedesign();
  const flagWaitExpired = useFlagResolveTimeout(bookingFlowRedesign.isResolved);

  if (is404) {
    return <NotFound />;
  }

  if (loading || !place?.id) {
    return null;
  }

  // TODO Ville
  // ProfilePage and PlacePageV2 should only read place from the redux store instead of receiving it as a prop.
  if (place.isExternalPlace) {
    return (
      <ListCardsV2Provider>
        <ProfilePage place={place} />
      </ListCardsV2Provider>
    );
  }

  return (
    <ConfidenceFlagProvider
      flagKey={MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY.name}
      defaultValue={MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY.defaultValue}>
      <ConfidenceFlagWrapper>
        {(flagValue) => (
          <BookAppointmentProvider
            place={place}
            config={{
              disableUrlSync: bookingFlowRedesign.enabled,
              urlSyncReady: bookingFlowRedesign.isResolved || flagWaitExpired,
            }}>
            <ListCardsV2Provider>
              <PlacePageV2 key={place.id} place={place} placeId={place.id} isSistaminuten={isSistaminuten} />
            </ListCardsV2Provider>
          </BookAppointmentProvider>
        )}
      </ConfidenceFlagWrapper>
    </ConfidenceFlagProvider>
  );
}
